<template>
  <v-menu
    v-model="open"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :left="align === 'right'"
    :nudge-bottom="4"
    max-width="290px"
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <div class="mobile-date-field">
        <span class="mobile-date-field__label">{{ label }}</span>
        <button
          type="button"
          class="mobile-date-field__btn"
          v-bind="attrs"
          v-on="on"
        >
          <span class="mobile-date-field__text">{{ displayValue }}</span>
          <v-icon size="18" color="primary">mdi-calendar</v-icon>
        </button>
      </div>
    </template>
    <v-date-picker
      :value="value"
      no-title
      :first-day-of-week="1"
      @input="onPick"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'MobileDateField',
  props: {
    label: { type: String, required: true },
    value: { type: String, default: null },
    align: { type: String, default: 'left' }
  },
  data() {
    return { open: false };
  },
  computed: {
    displayValue() {
      if (!this.value) return '—';
      const [y, m, d] = this.value.split('-');
      if (!y || !m || !d) return this.value;
      return `${d}/${m}/${y}`;
    }
  },
  methods: {
    onPick(next) {
      this.open = false;
      this.$emit('input', next);
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-date-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.mobile-date-field__label {
  color: var(--app-text);
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.mobile-date-field__btn {
  align-items: center;
  background: var(--app-surface);
  border: 1px solid var(--app-border-strong);
  border-radius: var(--app-radius);
  color: var(--app-text);
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  gap: 6px;
  justify-content: center;
  min-width: 0;
  padding: 8px 8px;
  width: 100%;
}

.mobile-date-field__btn:active {
  border-color: var(--app-primary);
}

.mobile-date-field__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
